export const GET_MODULES_REQUEST = 'GET_MODULES_REQUEST'
export const GET_MODULES_SUCCESS = 'GET_MODULES_SUCCESS'
export const GET_MODULES_ERROR = 'GET_MODULES_ERROR'
export const UPDATE_MODULES_REQUEST = 'UPDATE_MODULES_REQUEST'
export const UPDATE_MODULES_SUCCESS = 'UPDATE_MODULES_SUCCESS'
export const UPDATE_MODULES_ERROR = 'UPDATE_MODULES_ERROR'
